import { AlertTriangle } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { fmtPct } from "@/lib/format";

export default function AlertasMeta({ items = [], onSelect }) {
  if (!items.length) return null;
  return (
    <div
      data-testid="alertas-meta"
      className="rounded-xl border border-amber-500/40 bg-amber-500/5 p-5"
    >
      <div className="flex items-start justify-between gap-3 mb-3">
        <div className="flex items-start gap-3">
          <div className="w-9 h-9 rounded-lg bg-amber-500/15 text-amber-500 grid place-items-center shrink-0">
            <AlertTriangle className="w-4 h-4" />
          </div>
          <div>
            <div className="font-heading font-semibold text-base">Alertas de meta</div>
            <p className="text-xs sm:text-sm text-muted-foreground mt-0.5">
              Condomínios abaixo de 50% da meta com a semana já em andamento — priorize as ações desta semana.
            </p>
          </div>
        </div>
        <Badge
          variant="outline"
          className="bg-amber-500/15 text-amber-500 border-amber-500/40 shrink-0"
          data-testid="alertas-count"
        >
          {items.length} em risco
        </Badge>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
        {items.slice(0, 6).map((c) => (
          <button
            key={c.id}
            onClick={() => onSelect && onSelect(c)}
            className="group text-left rounded-lg border border-border bg-card hover:border-amber-500/60 transition-colors p-3 flex items-center justify-between gap-3"
            data-testid={`alerta-item-${c.id}`}
          >
            <div className="min-w-0">
              <div className="font-medium text-sm truncate">{c.condominio}</div>
              <div className="text-[11px] text-muted-foreground truncate">
                {c.responsavel || "Sem responsável"} · {c.semana_planejada || "Sem semana"}
              </div>
            </div>
            <div className="text-right shrink-0">
              <div className="text-sm font-bold text-red-500 tabular-nums">
                {fmtPct(c._percent)}
              </div>
              <div className="text-[10px] text-muted-foreground tabular-nums">
                {c.vendas_realizadas}/{c.meta_vendas}
              </div>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
}
